import {
  PermissionCategory,
  type Permission,
  PermissionType,
} from '@repo/api-gw-sdk';

export type PermissionDescriptor = Permission & {
  group?: string;
};

export const ManageBackupSettingsGroup = 'Manage backup settings';

const permissions: Record<PermissionType, { group?: string }> = {
  [PermissionType.GlobalSettingsView]: {},
  [PermissionType.VaultAccountsManage]: {},
  [PermissionType.CostExplorerView]: {},
  [PermissionType.AuditLogsView]: {},
  [PermissionType.UserAccessManage]: {
    group: 'Access management',
  },
  [PermissionType.SamlGroupAccessManage]: {
    group: 'Access management',
  },
  [PermissionType.ApiCredentialsManage]: {
    group: 'Access management',
  },
  [PermissionType.ApiCredentialsRotateSecret]: {
    group: 'Access management',
  },
  [PermissionType.CustomRolesManage]: {
    group: 'Access management',
  },
  [PermissionType.OauthAppsManage]: {
    group: 'Integrations',
  },
  [PermissionType.NotificationPoliciesManage]: {
    group: 'Integrations',
  },
  [PermissionType.PermissionIdUnspecified]: {},
  [PermissionType.DashboardView]: {},
  [PermissionType.InventoryView]: {},
  [PermissionType.JobsView]: {},
  [PermissionType.BackupSettingsView]: {},
  [PermissionType.StorageGatewayView]: {},
  [PermissionType.DatabaseExplorerSearch]: {
    group: 'Search and explore',
  },
  [PermissionType.FileExplorerSearch]: {
    group: 'Search and explore',
  },
  [PermissionType.FileExplorerDelete]: {},
  [PermissionType.StorageGatewayDataDownload]: {},
  [PermissionType.StorageGatewayMetadataView]: {},
  [PermissionType.SnapshotsTakeOrConvert]: {},
  [PermissionType.ResourcesRestore]: {},
  [PermissionType.ConfigurationValidate]: {},
  [PermissionType.FilesRestore]: {
    group: 'Restore granular data',
  },
  [PermissionType.DatabasesQuery]: {
    group: 'Restore granular data',
  },
  [PermissionType.DataClassesOverride]: {
    group: 'Override classifications',
  },
  [PermissionType.EnvironmentsOverride]: {
    group: 'Override classifications',
  },
  [PermissionType.DetectedAppsOverride]: {
    group: 'Override classifications',
  },
  [PermissionType.NetworkClassificationOverride]: {
    group: 'Override classifications',
  },
  [PermissionType.ControlViolationsMute]: {},
  [PermissionType.BackupExclusionManage]: {},
  [PermissionType.VaultsManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.SourceAccountsManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.RestoreAccountsManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.BackupPoliciesManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.DiscoveryConfigurationManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.BackupConfigurationManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.ZeroEtlPoliciesManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.ControlsManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.RansomwareDetectionManage]: {
    group: ManageBackupSettingsGroup,
  },
  [PermissionType.StorageGatewayManage]: {
    group: 'Storage gateway',
  },
  [PermissionType.ActionApprovalRulesManage]: {
    group: 'Access management',
  },
  [PermissionType.ActionApprovalRulesView]: {
    group: 'Access management',
  },
  [PermissionType.ActionApprovalRequestsManage]: {
    group: 'Access management',
  },
  [PermissionType.MpaPoliciesManage]: {
    group: 'Access management',
  },
  [PermissionType.MpaPoliciesView]: {
    group: 'Access management',
  },
  [PermissionType.MpaRequestsManage]: {
    group: 'Access management',
  },
  [PermissionType.RestoreTemplatesManage]: {},
  [PermissionType.DatalakeView]: {
    group: 'Managed data lake',
  },
  [PermissionType.DatalakeOperate]: {
    group: 'Managed data lake',
  },
  [PermissionType.ComplianceView]: {},
  [PermissionType.ClassificationPoliciesManage]: {},
};

export const Permissions = Object.fromEntries(
  Object.entries(permissions).filter(
    ([key]) => key !== PermissionType.PermissionIdUnspecified
  )
);

const permissionCategories: Record<PermissionCategory, { title: string }> = {
  [PermissionCategory.PERMISSION_CATEGORY_ADMINISTRATION]: {
    title: 'Administration',
  },
  [PermissionCategory.PERMISSION_CATEGORY_GLOBAL_MANAGEMENT]: {
    title: 'Global management',
  },
  [PermissionCategory.PERMISSION_CATEGORY_OPERATION]: {
    title: 'Operation',
  },
  [PermissionCategory.PERMISSION_CATEGORY_VIEWING]: {
    title: 'Viewing',
  },
};

export const PermissionCategories = Object.fromEntries(
  Object.entries(permissionCategories)
);
